export default function Profile({ user }) {
  return (
    <div>
      <h1>Profile</h1>
    </div>
  );
}
